const styles = {
  container: {
    fontFamily: 'AvenirNext',
    fontSize: '14px',
  },
  backItem: {
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: '14px',
  },
  label: {
    fontSize: '2em',
    fontFamily: 'AvenirNext-DemiBold',
    verticalAlign: 'middle',
  },
  bold: {
    fontFamily: 'AvenirNext-DemiBold',
  },
};

export default styles;
